/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { financeDetailsGetResponseSchema } from './financeDetailsGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getFinanceDetails200Schema = z.lazy(() => financeDetailsGetResponseSchema);

/**
 * @description 505 response
 */
export const getFinanceDetails505Schema = z.any();

export const getFinanceDetailsQueryResponseSchema = z.lazy(() => getFinanceDetails200Schema);
